import {
  Component,
  ChangeDetectionStrategy,
  Input,
  EventEmitter,
  Output,
} from '@angular/core';

import {
  IGradeUnitDayListItemDTO,
  GradeUnitDayListItemDTO,
} from '@models/grade-unit/grade-unit-day';
import { IPermissionCheck, PermissionCheck } from '@models/role';
import { StatusEnum } from '@models/status';

@Component({
  selector: 'app-grade-unit-day-presentation',
  templateUrl: './grade-unit-day-presentation.component.html',
  styleUrls: ['./grade-unit-day-presentation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GradeUnitDayPresentationComponent {
  @Input() public gradeUnitDay: IGradeUnitDayListItemDTO =
    new GradeUnitDayListItemDTO();
  @Input() public checkPermission: IPermissionCheck = new PermissionCheck();
  @Input() public pageDetails: string = '';

  @Output() public emitNavigateToDayItem = new EventEmitter<number>();

  public statusEnum = StatusEnum;

  public checkStatus(status: StatusEnum): {
    pending: boolean;
    ready: boolean;
  } {
    return {
      pending: status === StatusEnum.PENDING,
      ready: status === StatusEnum.READY,
    };
  }

  public getAltText(dayNumber: number): string {
    return `Day ${dayNumber} Cover Photo`;
  }

  public navigateToDayItem(dayNumber: number): void {
    this.emitNavigateToDayItem.emit(dayNumber);
  }
}
